import { useLazyQuery } from '@apollo/client';
import { GET_SURVEY_QUESTIONS } from '@pass-frontend/common/data-access';
import { SurveyQuestion } from '@pass-frontend/data-access/common/edge';

export function useGetSurveyQuestions() {
  const [fetchSurveyQuestions, { loading, error, data }] = useLazyQuery<{
    surveyQuestions: SurveyQuestion[];
  }>(GET_SURVEY_QUESTIONS);

  return {
    loading: loading ?? false,
    error,
    surveyQuestions: data,
    fetchSurveyQuestions: (surveyId: any) => {
      fetchSurveyQuestions({
        variables: { surveyId },
      });
    },
  };
}
